import { BlockRecord } from "models/view-models/block-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface SharedPageBlockPathParams {
    pageGuid: string;
}
export interface SharedPageBlockQueryParams {
    recipient?: string;
    skip?: number;
    take?: number;
}

const endpoint: string = "shared/pages/:pageGuid/blocks";
const resourceType = BlockRecord;

const SharedPageBlockService = {
    useGetByPage: ServiceHookFactory.useNestedList<
        BlockRecord,
        SharedPageBlockPathParams,
        SharedPageBlockQueryParams
    >(resourceType, endpoint),
};

export default SharedPageBlockService;
